import styles from './styles.module.scss';
import {useEffect} from 'react';
import nProgress from 'nprogress';
import {useAccountCreationLoaderShowState} from 'ui/@atoms/account-creation-loader-show';
import Coach from '/static/assets/images/coach.gif';
import Image from 'ui/@_components/image/image';
import PageTemplate from 'ui/@_components/page-template/page-template';
import useDeterminateProgressBar from 'ui/@hooks/use-determinate-progress-bar';
import HorizontalProgressBar from 'ui/@_components/progress-bar/horizontal/horizontal';

const CreatingAccount = () => {
  const [accountCreationLoaderShow, setAccountCreationLoaderShow] =
    useAccountCreationLoaderShowState();

  const percentage = useDeterminateProgressBar();

  useEffect(() => {
    if (accountCreationLoaderShow) {
      setTimeout(() => {
        setAccountCreationLoaderShow(false);
        nProgress.done();
      }, 9000);
    }
  }, [setAccountCreationLoaderShow, accountCreationLoaderShow]);

  useEffect(() => {
    if (accountCreationLoaderShow) {
      nProgress.start();
    } else {
      nProgress.done();
    }
  }, [accountCreationLoaderShow]);

  if (!accountCreationLoaderShow) {
    return null;
  }

  return (
    <PageTemplate hideNavigation v2Background>
      <div className={styles.container}>
        <Image
          src={Coach}
          alt="Creating Account"
          height="100px"
          width="100px"
          className={styles.img}
        />

        <HorizontalProgressBar
          size="small"
          wrapperBackgroundColor="rgba(255, 255, 255, 0.10)"
          progressBackgroundColor="linear-gradient(90deg, #3ad0f8 2.92%, #2961f6 89.2%)"
          percentage={percentage}
        />

        <p className={styles.title}>Loading your culture dashboard</p>
      </div>
    </PageTemplate>
  );
};

export default CreatingAccount;
